import { useState } from 'react';
import { ShippingAddressFragment } from '@graphql/aliases';
import { useSetRegistryAddressMutation } from '@graphql/generated';
import { AddressDialogFields, AddressDialogStep } from './types';

interface AddressDialogControllerProps {
  eventId: string;
  onClose: () => void;
  onSave?: (address: ShippingAddressFragment) => void;
}

export const useAddressDialogController = ({ eventId, onClose, onSave }: AddressDialogControllerProps) => {
  const [step, setStep] = useState<AddressDialogStep>(1);

  const [setRegistryAddress, { loading: mutationLoading }] = useSetRegistryAddressMutation({
    refetchQueries: () => ['GetAdminRegistryData', 'GetRegistryOnboardingSuggestions', 'PublicShopRoot'],
    awaitRefetchQueries: true,
  });

  const saveAddress = async (shippingAddressFields: AddressDialogFields) => {
    await setRegistryAddress({
      variables: {
        eventId,
        payload: {
          name: shippingAddressFields.name || '',
          phone: shippingAddressFields.phone || '',
          address1: shippingAddressFields.address1,
          address2: shippingAddressFields.address2 || '',
          city: shippingAddressFields.city,
          state: shippingAddressFields.state,
          postalCode: shippingAddressFields.postalCode || '',
          country: shippingAddressFields.country || '',
          countryCode: shippingAddressFields.countryCode || null,
          validated: shippingAddressFields.validated || false,
        },
      },
    });
    onSave?.(shippingAddressFields);
    setStep(1);
  };

  const handleClose = () => {
    setStep(1);
    onClose();
  };

  return {
    handleClose,
    step,
    setStep,
    saveAddress,
    mutationLoading,
  };
};
